export const Polite = 'polite'
